import { Link } from '@remix-run/react';

import Typography from '~/components/Typography';
import type { WebThemeV2 } from '~/interfaces/publication';

import NavGroupPopover from './NavGroupPopover';

interface Props {
  children: React.ReactNode;
  subLinks: any;
  theme: WebThemeV2;
}

const LinkPopover = ({ children, subLinks, theme }: Props) => {
  return (
    <NavGroupPopover
      theme={theme}
      popoverContent={
        // biome-ignore lint/complexity/noUselessFragments: Otherwise it will error because of the ternary
        <>
          {subLinks.map((sublink: any) => {
            const isExternalLink = sublink.external_link;

            if (isExternalLink) {
              return (
                <a
                  key={sublink.id}
                  className="flex rounded-wt px-3 py-2.5 hover:bg-black/5"
                  href={sublink.href}
                  target="_blank"
                  rel="nofollow noreferrer noopener"
                >
                  <Typography
                    as="span"
                    color={theme.navbar_text_color}
                    fontFamily={theme.navbar_font_family}
                    className="text-xs sm:block"
                  >
                    {sublink.cta_text}
                  </Typography>
                </a>
              );
            }

            return (
              <Link key={sublink.id} className="flex rounded-wt px-3 py-2.5 hover:bg-black/5" to={`/c/${sublink.href}`}>
                <Typography
                  as="span"
                  color={theme.navbar_text_color}
                  fontFamily={theme.navbar_font_family}
                  className="text-xs sm:block"
                >
                  {sublink.cta_text}
                </Typography>
              </Link>
            );
          })}
        </>
      }
    >
      {children}
    </NavGroupPopover>
  );
};

export default LinkPopover;
